// ============================================
// Creator Events - Index (ES6)
// 이벤트 모듈 통합 진입점
// ============================================

// Tab & Navigation
export {
  initCreatorTabEvents,
  initSearchModalEvents,
  initStatsModalEvents,
  initCreationTypeModalEvents
} from './tab.js';

// Editor
export { initCharacterEditorEvents } from './editor.js';

// Autofill
export { initAutofillModalEvents } from './autofill.js';

// Image
export {
  initImageGenModalEvents,
  initImageSelectionModalEvents,
  initImageDetailModalEvents
} from './image.js';

// Situational Images
export { initSituationalImageEvents } from './situational.js';

// Lorebook
export { initLorebookEvents } from './lorebook.js';

// Hashtags
export { initHashtagEvents } from './hashtags.js';

// ============================================
// 통합 초기화
// ============================================

import { initCreatorTabEvents, initSearchModalEvents, initStatsModalEvents, initCreationTypeModalEvents } from './tab.js';
import { initCharacterEditorEvents } from './editor.js';
import { initAutofillModalEvents } from './autofill.js';
import { initImageGenModalEvents, initImageSelectionModalEvents, initImageDetailModalEvents } from './image.js';
import { initSituationalImageEvents } from './situational.js';
import { initLorebookEvents } from './lorebook.js';
import { initHashtagEvents } from './hashtags.js';

export function initAllCreatorEvents() {
  initCreatorTabEvents();
  initSearchModalEvents();
  initStatsModalEvents();
  initCreationTypeModalEvents();
  initCharacterEditorEvents();
  initAutofillModalEvents();
  initImageGenModalEvents();
  initImageSelectionModalEvents();
  initImageDetailModalEvents();
  initSituationalImageEvents();
  initLorebookEvents();
  initHashtagEvents();
}
